import {AlertIcon, PlusIcon} from '@primer/octicons-react'
import {Button} from '@primer/react'

import styles from './AddIssueFieldButton.module.css'

type AddIssueFieldButtonProps = {
  anchorProps?: React.HTMLAttributes<HTMLElement> | undefined
  /// True if button should appear inactive with alert icon
  inactive?: boolean | undefined
  /// True if button should not be actionable
  disabled?: boolean | undefined
  onClick: () => void
  ref?: React.Ref<HTMLButtonElement>
}

export const AddIssueFieldButton = ({ref, ...props}: AddIssueFieldButtonProps) => {
  const {anchorProps, inactive = false, disabled = false, onClick} = props
  return (
    <div className={styles.container}>
      <Button
        leadingVisual={inactive ? AlertIcon : undefined}
        trailingVisual={!inactive ? PlusIcon : undefined}
        size="small"
        ref={ref}
        {...anchorProps}
        className={styles.button}
        inactive={inactive || disabled}
        onClick={event => {
          if (disabled) return
          onClick()
          anchorProps?.onClick?.(event)
        }}
      >
        Add field
      </Button>
    </div>
  )
}
AddIssueFieldButton.displayName = 'AddIssueFieldButton'
